import { ArtworkApprovalRequestType, ArtworkApprovalRequestTypes } from "./data.type";


const setStateValue = (key:ArtworkApprovalRequestTypes, value:any):ArtworkApprovalRequestType => ({
  type: key,
  payload: value,
});


export const ArtworkApprovalActions = {
  setStateValue,
};
